import { Slider } from "@/components/ui/slider";
import { eur } from "@/lib/api";

const Section = ({ title, children }) => (
  <div className="border-b border-stone pb-6 mb-6">
    <p className="text-xs uppercase tracking-[0.2em] text-ink mb-4">{title}</p>
    {children}
  </div>
);

const Chip = ({ active, onClick, children, testid }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    className={`text-xs px-3.5 py-2 border transition-colors ${
      active ? "bg-ink text-cream border-ink" : "border-stone text-graphite hover:border-ink"
    }`}
  >
    {children}
  </button>
);

export const FilterPanel = ({ options, filters, setFilters, priceRange, setPriceRange }) => {
  if (!options) return null;
  const toggle = (key, value) =>
    setFilters((f) => ({ ...f, [key]: f[key] === value ? "" : value }));

  return (
    <div data-testid="filter-panel">
      <Section title="Type de projet">
        <div className="flex flex-wrap gap-2">
          {options.types.map((t) => (
            <Chip key={t} testid={`filter-type-${t}`} active={filters.type === t} onClick={() => toggle("type", t)}>
              {t}
            </Chip>
          ))}
        </div>
      </Section>

      <Section title="Formule">
        <div className="flex flex-wrap gap-2">
          {options.styles.map((s) => (
            <Chip key={s} testid={`filter-style-${s}`} active={filters.style === s} onClick={() => toggle("style", s)}>
              {s}
            </Chip>
          ))}
        </div>
      </Section>

      <Section title="Plateforme">
        <div className="flex flex-wrap gap-2">
          {options.rooms.map((r) => (
            <Chip key={r} testid={`filter-room-${r}`} active={filters.room === r} onClick={() => toggle("room", r)}>
              {r}
            </Chip>
          ))}
        </div>
      </Section>

      <Section title="Prix">
        <Slider
          data-testid="filter-price-slider"
          min={options.price_min}
          max={options.price_max}
          step={5}
          value={priceRange}
          onValueChange={setPriceRange}
          className="mt-2"
        />
        <div className="flex justify-between mt-3 font-mono text-xs text-graphite">
          <span>{eur(priceRange[0])}</span>
          <span>{eur(priceRange[1])}</span>
        </div>
      </Section>

      <button
        data-testid="clear-filters-btn"
        onClick={() => {
          setFilters({ type: "", style: "", room: "" });
          setPriceRange([options.price_min, options.price_max]);
        }}
        className="text-xs uppercase tracking-[0.15em] underline underline-offset-4 text-ash hover:text-ink"
      >
        Réinitialiser les filtres
      </button>
    </div>
  );
};
